var map = {
	"./ChipWar.js": 3498,
	"./DataFundamentals.js": 1012,
	"./FavoriteDataScienceLibraries.js": 1597,
	"./FooledByRandomness.js": 5916,
	"./GunsGermsAndSteel.js": 829,
	"./HappinessHypothesis.js": 2593,
	"./HowTheWorldReallyWorks.js": 8474,
	"./HowToLieWithStatistics.js": 9932,
	"./InvisibleWomen.js": 4423,
	"./Mindfck.js": 6062,
	"./Outliers.js": 6161,
	"./PrisonersOfGeography.js": 1878,
	"./TalkingToStrangers.js": 1890,
	"./TheCourageToBeDisliked.js": 2528,
	"./TheMythOfSisyphus.js": 7746,
	"./TheSixthExtinction.js": 3654,
	"./TheWorldForSale.js": 917,
	"./WeaponsOfMathDestruction.js": 3050,
	"./WhereGoodIdeasComeFrom.js": 94,
	"./WhyLearnData.js": 9360,
	"./ZeroToOne.js": 9663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1325;